import { Autoplay, FreeMode } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

export const swiperConfig: SwiperOptions = {
  autoplay: {
    delay: 0,
    pauseOnMouseEnter: true,
    disableOnInteraction: false,
  },
  slidesPerView: 'auto',
  speed: 5000,
  freeMode: true,
  grabCursor: true,
  centerInsufficientSlides: true,
  spaceBetween: 24,
  modules: [Autoplay, FreeMode],
};
